module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_reason02-416e6021ba43072e8fd663036a906974.png";